import React, { useState, useEffect } from 'react';
import AdminAppBody from '../../../../components/admin/AdminAppBody';
import { FaEllipsisV } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import useApiCallHooks from '../../../../hooks/useApiCallHooks';
import { uiRoutes } from '../../../../routes/ui/uiRoutes';
const MentorStudentList = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [students, setStudents] = useState([]);
  const [response, loading, error, callAPI] = useApiCallHooks();
  useEffect(() => {
    callAPI('post', 'mentor/mentor-student-list', {});
  }, []);
  useEffect(() => {
    if (response?.data) {
      setStudents(response.data);
    }
  }, [response]);
  const filteredStudents = students.filter(item => {
    const firstName = item.student?.first_name || '';
    const lastName = item.student?.last_name || '';
    const programName = item.program?.name || '';
    const email = item.student?.email || '';
    return (
      (firstName + ' ' + lastName).toLowerCase().includes(searchTerm.toLowerCase()) ||
      programName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      email.toLowerCase().includes(searchTerm.toLowerCase())
    );
  });
  return (
    <AdminAppBody
      loading={loading}
      content={
        <div className="container mt-4">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4>Student List</h4>
            <div className="input-group w-25">
              <input
                type="text"
                className="form-control"
                placeholder="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <span className="input-group-text">
                <i className="bi bi-search"></i>
              </span>
            </div>
          </div>
          <table className="table table-bordered table-hover">
            <thead className="table-primary">
              <tr>
                <th>Sr No</th>
                <th>Student Name</th>
                <th>Program</th>
                <th>Email</th>
                <th>Mobile No</th>
                <th>More</th>
              </tr>
            </thead>
            <tbody>
              {filteredStudents.length > 0 ? (
                filteredStudents.map((item, idx) => (
                  <tr key={item.id}>
                    <td>{idx + 1}</td>
                    <td className="d-flex align-items-center gap-2">
<div
  className="rounded-circle bg-secondary text-white d-flex justify-content-center align-items-center overflow-hidden"
  style={{ width: 35, height: 35 }}
>
  {item.student?.profile_pic ? (
    <img
      src={item.student.profile_pic}
      alt="Profile"
      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
    />
  ) : (
    <i className="bi bi-person fs-5"></i>
  )}
</div>

                      <span>
                        {item.student?.first_name || ''} {item.student?.last_name || ''}
                      </span>
                    </td>
                    <td>{item.program?.name || '-'}</td>
                    <td>{item.student?.email || '-'}</td>
                    <td>{item.student?.mobile_no || '-'}</td>
                    <td className="position-relative">
                      <div className="dropdown">
                        <button
                          className="btn p-0 border-0 bg-transparent shadow-none text-dark"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <FaEllipsisV />
                        </button>
                        <div className="dropdown-menu dropdown-menu-end mt-2" style={{ minWidth: '200px' }}>
      <Link to={`/mentor/student-profile/${item.student.slug}`} className="dropdown-item ">
  View Profile
</Link>
                       <Link to={`/mentor/student-task/${item.student.slug}`}  className="dropdown-item">View Task</Link>
                        <Link to={uiRoutes.mentor.AssignTask.add}> <button className="dropdown-item">Assign Task</button></Link>  
          <Link to={`/mentor/student-session/${item.student.slug}`} >     <button className="dropdown-item">Schedule Sessions</button>  </Link>      
                          {/* <button className="dropdown-item">View Assessment</button> */}
                          {/* <button className="dropdown-item">Completed Roadmap</button> */}
                        </div>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center">No students found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      }
    />
  );
};
export default MentorStudentList;